import { Link } from 'react-router-dom';
import { glossInline } from '@shared/ptEn';
import {
  ChevronRightIcon,
  EventsIcon,
  AlertIcon,
  MedicalIcon,
  EmergencyIcon,
  ExploreIcon,
  FlightsIcon,
  SettingsIcon,
  ForMeIcon,
  SpeakerIcon,
} from '@/components/Icons';

const ITEMS = [
  { to: '/favorites', label: 'Favorites', icon: ForMeIcon, description: 'Saved places on this device' },
  { to: '/events', label: "What's On", icon: EventsIcon, description: 'Next few days around Carvoeiro' },
  { to: '/medical', label: 'Medical', icon: MedicalIcon, description: 'Farmácia, hospital in Portimão' },
  { to: '/emergency', label: 'Emergency', icon: EmergencyIcon, description: '112 and urgent contacts' },
  { to: '/safety', label: 'Beach & travel safety', icon: AlertIcon, description: 'Cliffs, UV, swell, and Algarve weather tips' },
  { to: '/pronunciation', label: 'Pronunciation guide', icon: SpeakerIcon, description: 'Hear common Algarve and Portuguese terms' },
  { to: '/explore', label: 'Explore', icon: ExploreIcon, description: 'Day trips beyond town' },
  { to: '/flights', label: 'Flights', icon: FlightsIcon, description: 'EWR ↔ LIS picker' },
  { to: '/settings', label: 'Settings', icon: SettingsIcon, description: 'App info and cache version' },
];

export function MorePage() {
  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">More</h1>
      </div>
      <div className="card" style={{ padding: 0 }}>
        {ITEMS.map(({ to, label, icon: Icon, description }) => (
          <Link key={to} to={to} className="list-row" style={{ padding: 16 }}>
            <span style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <Icon />
              <span>
                <strong style={{ display: 'block' }}>{label}</strong>
                <small className="muted">{glossInline(description)}</small>
              </span>
            </span>
            <ChevronRightIcon />
          </Link>
        ))}
      </div>
    </div>
  );
}
